import { render, staticRenderFns } from "./ToolboxWorker.vue?vue&type=template&id=163f8984"
import script from "./ToolboxWorker.vue?vue&type=script&lang=js"
export * from "./ToolboxWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports